









import {apiV1AdminRecruitPath, apiV1AdminRecruitsPath} from '@/rails/routes'
import {Component} from 'vue-property-decorator'
import PostForm from '@/components/admin/PostForm.vue'
import PostNew from '@/components/admin/PostNew'
import Post, {IPost} from '@/models/Post'
import AddinForm from '@/components/admin/recruits/AddinForm.vue'
import Recruit, {IRecruit} from '@/models/Recruit'
import AddinTags from '@/components/admin/recruits/AddinTags.vue'
import {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    PostForm,
    AddinForm,
    AddinTags
  }
})
export default class RecruitNew extends PostNew {
  path = 'recruits'
  createPath = apiV1AdminRecruitsPath()

  mounted(): Promise<void> {
    this.targetPath = apiV1AdminRecruitPath('new')
    this.tagCategory = 'recruit_cat'
    return super.mounted()
  }

  toFrontModel(data: IPost): Post {
    return new Recruit(data as IRecruit)
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: '求人情報一覧',
        to: '/admin/recruits',
        exact: true
      },
      {
        text: '求人情報新規作成'
      }
    ]
  }
}
